var SimulateRemotePermissionChecker = /** @class */ (function () {
    function SimulateRemotePermissionChecker(ownedPermissions) {
        this.ownedPermissions = ownedPermissions;
    }
    SimulateRemotePermissionChecker.prototype.isGranted = function (permissions) {
        for (var i = 0; i < this.ownedPermissions.length; i++) {
            if (permissions.indexOf(this.ownedPermissions[i]) !== -1) {
                return true;
            }
        }
        return false;
    };
    return SimulateRemotePermissionChecker;
}());
export { SimulateRemotePermissionChecker };
